export default [
    {
        name: 'header',
        type: 'string',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: 'txt',
        type: 'string',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: '__slot:ads_domain',
        sortField: 'domain',
        sortable: false,
        type: 'string',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: '__slot:ads_url',
        sortField: 'url',
        sortable: false,
        type: 'string',
        useInFilter: true
    },
    {
        name: 'region',
        type: 'regions',
        useInFilter: true
    },
    {
        name: '__slot:keyscnt_group',
        sortField: 'keyscnt',
        dataClass: 'ral',
        type: 'number',
        useInFilter: true,
        isDefault: true
    },
    {
        name: 'serp',
        sortField: 'serp',
        type: 'dateRange',
        dataClass: 'ral',
        useInFilter: true,
    },
]
